import NewsAndEvents from './NewsAndEvents'

export default NewsAndEvents
